import { createSlice } from '@reduxjs/toolkit';

import { PIK_LANDING_PATH } from '../../constants/pikPromoBanner';
import { IPikPromoBanner } from '../../types/pikPromoBanner';

const initialState: IPikPromoBanner = {
  hitUrl: PIK_LANDING_PATH,
  disclaimer: null,
};

export const pikPromoBannerSlice = createSlice({
  name: 'pikPromoBanner',
  initialState,
  reducers: {},
});

export const pikPromoBannerReducer = pikPromoBannerSlice.reducer;
